import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'context'
import {
    MASTER_ANSWERS_COMPANY_ID,
    MasterAnswersPage,
} from 'page-components/master-answers'

export const MasterAnswersScreen = () => {
    const { user } = useAuth()
    const companyId =
        user?.CompanyId || user?.Companies?.[0]?.CompanyId

    if (Number(companyId) !== MASTER_ANSWERS_COMPANY_ID) {
        return <Navigate to="/app/templates" replace />
    }

    return <MasterAnswersPage companyId={MASTER_ANSWERS_COMPANY_ID} />
}
